import axios from 'axios'; 



const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {'Content-Type': "application/json"}, 
    withCredentials: true
});


export class PrinterFetchAPI{ 

    static async getTempOrderByPrint(token, order_id){ 
        const res = await server(`/temp/print/order/${order_id}`, {
            method: 'get', 
            headers: token ? { 'x-access-token': token } : undefined
        }); 
        return res
    }

    static async getPrinter(token, machine_id){ 
        const res = await server(`/printer_per_machine/${machine_id}`, {
            method: 'get', 
            headers: token ? { 'x-access-token': token } : undefined
        }); 
        return res
    }

    static async updateIpPrinter(token, machine_id, printer_id, ip_Update){ 
        const res = await server(`/printer_per_machine/${machine_id}/${printer_id}`, {
            method: 'put',
            data: {ip: ip_Update},
            headers: token ? { 'x-access-token': token } : undefined
        }); 
        return res
    }

       //request print order windows local c#
       static async printOrder(data, endpoint) {
        const payment = JSON.stringify(data);
        let response = await axios.post("http://localhost:9090/impresion", payment);

        let jsonResponse = {data: response}
        return jsonResponse;
    }

    static async printPreOrder(data, endpoint) {
        const payment = JSON.stringify(data);
        let response = await axios.post("http://localhost:9090/impresion", payment);

        let jsonResponse = {data: response}
        return jsonResponse;
    }
}